<script>
export default {
  props: [
    'icon',
    'header',
    'body',
    'href',
    'button',
  ],
};
</script>

<template>
  <div class="manager-card is-flex">
    <font-awesome-icon
      :icon="['fal', `${icon}`]"
      class="fa-3x has-text-primary"
    />
    <h5 class="shortcut-header is-h5 has-text-weight-bold">
      {{ header }}
    </h5>

    <div class="card-text has-text-left">
      {{ body }}
    </div>
    <router-link
      :to="{ name: `${href}` }"
      class="is-flex shortcut-button"
    >
      <button class="button is-primary is-fullwidth">
        {{ button }}
      </button>
    </router-link>
  </div>
</template>

<style lang="sass" scoped>
  @import "@/sass/custom.sass"
  @import "~bulma/bulma"
  .manager-card
    margin: 0 1rem 1rem 0
    padding: 1rem
    border: 1px solid $grey-lighter
    width: 200px
    flex-direction: column
    align-items: center
  .shortcut-header
    margin-top: 1rem
  .shortcut-button
    height: 100%
    align-items: flex-end
    text-decoration: none !important
    color: inherit
  .shortcut-button:link,
  .shortcut-button:visited,
  .shortcut-button:active,
  .shortcut-button:hover
    text-decoration: none !important
  .button
    margin-top: 1rem
</style>
